export var createMapFromDictionary = function createMapFromDictionary(dictionaryValues) {
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  return mapDictionary;
};